import React from 'react';
import './Spinner.scss'; // Importa el archivo CSS para el spinner

const Spinner = ({className=""}:{className?:string}) => {
    return (
        <div className={`spinner ${className}`}></div>
    );
};

export default Spinner;